import Shelves from './Shelves.jsx'

/* THE HOME IS THE ATRIUM (owner call 2026-09-20: refractions' portfolio
   atrium, "put these doors on the homepage"). Layer zero: every dictionary at
   once, the master dictionary last, the maker after it. The figures that stood
   here (2026-09-19, "the home is the numbers") retire — the count on each
   tile is the figure now, and the tile is the door. See Shelves.jsx. */
export default function Home({ words: all, shelves, lens, visits, onShelf, onMintShelf, onDeleteShelf, onRenameShelf, onSetAnti, onDuplicateShelf, onExportShelf, onDropWords, onReorderShelves }) {
  const words = all.filter(w => !w.owner)   // the dictionaries are YOUR words; a friend's stay theirs
  return <Shelves words={words} shelves={shelves} lens={lens} visits={visits} onOpen={onShelf} onMint={onMintShelf} onDelete={onDeleteShelf} onRename={onRenameShelf} onSetAnti={onSetAnti} onDuplicate={onDuplicateShelf} onExport={onExportShelf} onDropWords={onDropWords} onReorder={onReorderShelves} />
}
